/**
 * Decorator to be used on class definition to apply mixins.
 * Note: if using `customElement` decorator, make sure it's the first one.
 *
 * Based on Stage 3 Decorators proposal as of 2023-11: https://github.com/tc39/proposal-decorators
 *
 * @param {function} mixinFunction - mixin function that is to be applied to the class
 * @return {function(function, {name: string, kind: string}): function} - decorator
 */
export default function mixin(mixinFunction) {
  return (value, { name, kind }) => {
    if (kind !== 'class') {
      throw new Error(
        `Using 'mixin' decorator on '${name}' which is of kind '${kind}'. This decorator is only meant for classes.`,
      );
    }

    return mixinFunction(value);
  };
}
